// Mục "Xu phát ra": cột Xu phát/thu hồi theo ngày + tròn cơ cấu theo nguồn.
import { Card, Col, Row } from "antd";
import { Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import XuEmptyHint from "./xu-empty-hint";
import { shortDate, useXuChart } from "./xu-chart-style";
import { fmtNum, sourceLabel } from "./xu-format-helpers";

export default function XuStatsXuSection({ days, bySource }) {
    const { chart, tooltip } = useXuChart();
    const hasXu = days.some((d) => d.earned || d.revoked);
    const pie = bySource.map((s) => ({ name: sourceLabel(s.source), value: s.xu })).filter((s) => s.value > 0);
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={14}>
                <Card size="small" title="Xu phát và thu hồi theo ngày" className="shadow-sm h-full">
                    {!hasXu ? <XuEmptyHint title="Chưa phát Xu nào trong khoảng này" hint="Khi có người điểm danh hoặc nhận thưởng nhiệm vụ, biểu đồ sẽ hiện ở đây." /> : (
                        <ResponsiveContainer width="100%" height={260}>
                            <BarChart data={days.map((d) => ({ ...d, label: shortDate(d.vnDate) }))}>
                                <CartesianGrid stroke={chart.grid} strokeDasharray="3 3" />
                                <XAxis dataKey="label" stroke={chart.axis} fontSize={12} />
                                <YAxis stroke={chart.axis} fontSize={12} />
                                <Tooltip {...tooltip} formatter={(v) => `${fmtNum(v)} Xu`} />
                                <Legend />
                                <Bar dataKey="earned" name="Xu phát" fill={chart.series[2]} radius={[3, 3, 0, 0]} />
                                <Bar dataKey="revoked" name="Xu thu hồi" fill={chart.series[0]} radius={[3, 3, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    )}
                </Card>
            </Col>
            <Col xs={24} lg={10}>
                <Card size="small" title="Xu phát theo nguồn" className="shadow-sm h-full">
                    {!pie.length ? <XuEmptyHint compact title="Chưa có dữ liệu nguồn Xu" /> : (
                        <ResponsiveContainer width="100%" height={260}>
                            <PieChart>
                                <Pie data={pie} dataKey="value" nameKey="name" innerRadius={50} outerRadius={85} paddingAngle={2}>
                                    {pie.map((_, i) => <Cell key={i} fill={chart.series[i % chart.series.length]} />)}
                                </Pie>
                                <Tooltip {...tooltip} formatter={(v) => `${fmtNum(v)} Xu`} />
                                <Legend />
                            </PieChart>
                        </ResponsiveContainer>
                    )}
                </Card>
            </Col>
        </Row>
    );
}
